import TextInput from "components/form/input/TextInput";
import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields";
import IBF from "..";

export function IBFParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={IBF.field + tipoIndicadorField}
            bottomFields={
                <>
                    <ParamFormRow label="Meta">
                        <TextInput name="mecanizado.meta" label="Meta (%)" type="number" />
                    </ParamFormRow>
                </>
            }
        />
    );
}
